document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.popular-products').forEach(function (section) {
    var items = section.querySelectorAll('.popular-products__wrapper > li');
    var hasRealProduct = false;

    items.forEach(function (item) {
      var isPlaceholder =
        item.classList.contains('popular-products__item_placeholder') ||
        item.querySelector('.card--product-placeholder');
      if (!isPlaceholder) hasRealProduct = true;
    });

    if (items.length === 0 || !hasRealProduct) {
      var wrapper = section.closest('[id^="shopify-section-"]') || section;
      wrapper.remove();
    }
  });

   document.querySelectorAll('.brands-section .brands__images').forEach(function (container) {
    const wrappers = container.querySelectorAll('.brands__image-wrapper');

    wrappers.forEach(function (wrapper) {
      const hasRealImage = wrapper.querySelector('img') !== null;
      if (!hasRealImage) {
        wrapper.remove();
      }
    });

    const remaining = container.querySelectorAll('.brands__image-wrapper');
    remaining.forEach(function (wrapper, index) {
      wrapper.style.opacity = index === 0 ? '1' : '0';
      wrapper.style.zIndex = index === 0 ? '1' : '0';
    });
  });

  document.querySelectorAll('.image-banner').forEach(function (section) {
    var placeholder = section.querySelector('.banner__media .placeholder-svg');
    if (placeholder) {
      section.remove();
    }
  });
});